import { styled } from "styled-components";
import { Product } from "@ludens-reklame/rubics-v3-sdk/product/types";
import { ProductProps } from "../../types/product.js";

interface Props {
  product: Product<ProductProps>;
  priceClass?: string;
  prefixClass?: string;
  suffixClass?: string;
  compareAtPriceClass?: string;
}

export const ProductPrice: React.FC<Props> = ({
  product,
  priceClass,
  prefixClass,
  suffixClass,
  compareAtPriceClass,
}) => {
  return (
    <Wrapper className="product-price">
      <p>
        {product.pricePrefix ? (
          <span className={prefixClass}>{product.pricePrefix} </span>
        ) : null}
        <span className={`price ${priceClass || ""}`}>{product.priceText}</span>
        {product.priceSuffix ? (
          <span className={suffixClass}> {product.priceSuffix}</span>
        ) : null}
      </p>
      {typeof product.compareAtPrice === "number" && (
        <p className={`compare-price ${compareAtPriceClass || ""}`}>
          Før {product.compareAtPriceText}
        </p>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  p {
    margin: 0;
  }

  .compare-price {
    text-decoration: line-through;
  }
`;
